import React from "react";
import { Flex, Box, useColorMode } from "@chakra-ui/react";

export const CommonFooter: React.FC = () => {
  const { colorMode } = useColorMode();
  const textColor = colorMode === "dark" ? "white" : "gray.500";

  return (
    <Box
      as="footer"
      borderTop="1px solid"
      _dark={{ borderTopColor: "theme.gray.200" }}
      borderTopColor={"theme.gray.100"}
      px={{ base: "24px", md: "40px", lg: "77px" }}
      py={{ base: "16px", md: "16px" }}
      width="100%"
    >
      <Flex direction="column" align="center" gap="2px">
        <Box
          color={textColor}
          fontSize={"10px"}
          fontWeight={"400"}
          textAlign="center"
        >
          (한국신문윤리위원회 사무국) T. 02-734-3081~3083 | E.{" "}
          <Box
            as="a"
            href="https://ikpec.or.kr/m2/sub0_edu.asp"
            target="_blank"
            rel="noopener noreferrer"
           color={"blue.500"}
            textDecoration="underline"
          >
            Email
          </Box>
        </Box>
        {/* <Box
          color={textColor}
          fontSize={"10px"}
          fontWeight={"400"}
          textAlign="center"
        >
          (시스템 문의) T. 02-6204-0139 | doaz@doaz.ai
        </Box> */}
         <Box
          color={textColor}
          fontSize={"10px"}
          fontWeight={"400"}
          textAlign="center"
        >
          Contents Copyright 한국신문윤리위원회. All Rights Reserved.
        </Box>
        <Box
          as="a"
          href="https://www.ikpec.or.kr/m2/sub0_privacy_edu.asp"
          target="_blank"
          rel="noopener noreferrer"
          color={"blue.500"}
          fontSize={"10px"}
          fontWeight={"400"}
          textDecoration="underline"
          textAlign="center"
        >
          개인정보처리방침
        </Box>
      </Flex>
    </Box>
  );
};
